const classicDark = {
  id: 'classicDark',
  displayName: 'Classic Dark',
  enabled: true,
  graph: {
    writeSample: '#FFFF00', writeTrend: '#FFFFFF', writeMax: '#00FF00',
    writeMin: '#FF0000', writeLatency: '#00FFFF',
    readSample: '#D3D3D3', readTrend: '#FFA500', readMax: '#006400',
    readMin: '#8B0000', readLatency: '#FF00FF',
  },
  canvas: {
    chartBg: '#333333', gridColor: '#555555', textColor: '#ADB5BD',
  },
};
export default classicDark;
